module.exports = __webpack_public_path__ + "static/media/teygja_axlir_small.2b610f9f.png";